import { connect } from 'react-redux';
import DataMapDetailActions from './DataMapDetailActions';
import { deleteDataMap } from '../../../actions';
import { useResourceDetailHandler } from 'new/components/ResourceDetailHandler/context';

function DataMapDetailActionsWithContext(props) {
  const { openDetailDrawerInPortal } = useResourceDetailHandler();
  return <DataMapDetailActions {...props} openDetailDrawerInPortal={openDetailDrawerInPortal} />;
}

export default connect(null, { deleteDataMap })(DataMapDetailActionsWithContext);
